import { type Translations } from '@/libs/translation';

import { type MediaResponse } from '.';

export interface GamificationBadgeCollectionFAQ {
  id: string;
  question: string;
  answer: string;
  contentI18n: Translations<{ question: string; answer: string }>;
}

interface GamificationBadgeLogo {
  media?: MediaResponse | null;
  isCustom: boolean;
}

export interface GamificationBadgeLogos {
  name: string;
  weighting: number;
  media?: MediaResponse | null;
  isCustom: boolean;
}

export interface GamificationBadgeCollectionConfig {
  isEnabled: boolean;
  id?: string;
  badgeLogo?: GamificationBadgeLogo;
  badgeLogos?: GamificationBadgeLogos[];
  attendeeMaxBadgeCollectionPerDay?: number;
  excludedAreas?: ExcludedBadgeCollectionAreaOptions[];
  faq?: GamificationBadgeCollectionFAQ[];
}

export interface UpsertGamificationBadgeCollectionConfigRequest {
  isEnabled?: boolean;
  badgeLogos?: Array<{
    name: string;
    weighting: number;
    mediaId?: string | null;
    isCustom: boolean;
  }>;
  attendeeMaxBadgeCollectionPerDay?: number;
  excludedAreas?: ExcludedBadgeCollectionAreaOptions[];
  faq?: GamificationBadgeCollectionFAQ[];
}

export interface SpotGamificationBadgeCollectionFAQ {
  question: string;
  answer: string;
}

export interface SpotGamificationBadgeCollectionConfig
  extends Pick<
    GamificationBadgeCollectionConfig,
    | 'id'
    | 'badgeLogo'
    | 'badgeLogos'
    | 'isEnabled'
    | 'attendeeMaxBadgeCollectionPerDay'
    | 'excludedAreas'
  > {
  faq?: SpotGamificationBadgeCollectionFAQ[];
}

export enum ExcludedBadgeCollectionAreaOptions {
  WEBINAR = 'webinar',
}
